export const POLLING_START = 'polling/POLLING_START';
export const POLLING_STOP = 'polling/POLLING_STOP';
export const POLLING_SET_TIMEOUT = 'polling/POLLING_SET_TIMEOUT';

function polling(state = {}, action) {
  const key = action.payload && action.payload.object;
  switch (action.type) {
    case POLLING_START:
      return Object.assign({}, state, {
        [key]: {
          isPolling: true,
          timeoutId: '',
        },
      });
    case POLLING_SET_TIMEOUT:
      return Object.assign({}, state, {
        [key]: {
          isPolling: true,
          timeoutId: action.payload.timeoutId,
        },
      });
    case POLLING_STOP:
      return Object.assign({}, state, {
        [key]: {
          isPolling: false,
          timeoutId: '',
        },
      });
    default:
      return state;
  }
}

export default polling;



// WEBPACK FOOTER //
// ./src/reducers/polling.js